import React, { useEffect, useState } from 'react';

const COOKIE_KEY = 'qroke:cookieConsent:v1';

const CookieBanner: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(COOKIE_KEY);
      setShow(v !== '1');
    } catch {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50">
      <div className="mx-auto max-w-7xl m-3 rounded-lg bg-black/80 text-white border border-white/10 p-4 shadow-lg">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <div className="text-sm text-gray-200">
            We use browser storage (localStorage) to improve your experience
            {' '}<a className="underline hover:text-white" href="https://qroke.org/privacy-policy-for-qroke" target="_blank" rel="noopener">Privacy Policy</a>.
          </div>
          <div className="ml-auto flex gap-2">
            <button
              className="px-3 py-1 rounded bg-white/20 hover:bg-white/30 text-white text-sm"
              onClick={() => {
                try { localStorage.setItem(COOKIE_KEY, '1'); } catch {}
                setShow(false);
              }}
            >
              Accept
            </button>
            <a
              className="px-3 py-1 rounded bg-transparent border border-white/20 hover:bg-white/10 text-white text-sm"
              href="https://qroke.org/privacy-policy-for-qroke" target="_blank" rel="noopener"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
